var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort"},[_c('div',{staticClass:"sort__title"},[_vm._v("Sortieren nach")]),_c('Select',{staticClass:"sort__select",attrs:{"listArr":_vm.sorts,"currentItem":_vm.selected},on:{"change":_vm.onChangeFirst}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }